import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, watch } from 'vue'
  import Signup from '@/components/Signup.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import useIcons from '@/composables/useIcons'
  import useBreakpoint from '@/composables/useBreakpoint'
  import { UserModule } from '@/store/modules/user'
  import CookieHelper from '@/helpers/CookieHelper'
  import type { Company } from '@/services/interfaces/Auth0'
  import useSegment from '@/composables/useSegment'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OtherAcademiesSignup',
  setup(__props) {

  const { specialCheckmark, curvedDownArrow, defaultLogo } = useIcons()
  const { isMobileDevice } = useBreakpoint()
  const { trackPage, pageViewed } = useSegment()

  const customSignupProperties = computed(() => UserModule.signupPageProperties)

  const loadingProperties = computed(() => customSignupProperties.value === null)

  const companySubdomainDetails = computed(() => UserModule.companySubdomainDetails || UserModule.company)

  const pageTitleColor = computed(() => {
    return customSignupProperties.value?.customTitleColor
      ? customSignupProperties.value.customTitleColor
      : 'var(--hero-foreground-color)'
  })

  watch(companySubdomainDetails, (value: Company | null) => {
    if (value) {
      CookieHelper.setCrossDomainCookie('company_subdomain_details', JSON.stringify(companySubdomainDetails.value))
    }
  })

  onMounted(() => {
    if (UserModule.onboarded) {
      window.location.href = '/'
    } else if (!UserModule.hasValidUser) {
      trackPage('Registration')
      pageViewed('Registration')
    }
  })

  if (companySubdomainDetails.value) {
    CookieHelper.setCrossDomainCookie('company_subdomain_details', JSON.stringify(companySubdomainDetails.value))
  }

return { __sfc: true,specialCheckmark, curvedDownArrow, defaultLogo, isMobileDevice, trackPage, pageViewed, customSignupProperties, loadingProperties, companySubdomainDetails, pageTitleColor, computed, onMounted, watch, Signup, SVGRenderer, HTMLRenderer, LoadingSpinner, useIcons, useBreakpoint, UserModule, CookieHelper, useSegment }
}

})